<template>
  <div class="flex gap-4 items-center justify-between">
    <CTableInput
      :always-display-edit-icon="true"
      :class="{ 'w-full max-w-[400px]': getInputState(activeInputId === COLLECTION_NAME_KEY) === 'edit' }"
      :max-length="64"
      :model-value="
        getInputState(activeInputId === COLLECTION_NAME_KEY) === 'view'
          ? collection.name || t('canvasUI.pptConversionSelector.defaultNewCollectionName')
          : collection.name
      "
      :state="getInputState(activeInputId === COLLECTION_NAME_KEY)"
      value-class="color-primary font-size-5 line-height-8 tracking-[0.25px]"
      @cancel="clearActiveInput()"
      @edit="setActiveInput(COLLECTION_NAME_KEY)"
      @update:modelValue="updateCollectionName"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import CTableInput from '@lib/components/CTableInput/CTableInput.vue'
import { useTableInput } from '@ppt-conversion-selector/composables/table-input.use'
import { useAppStore } from '@ppt-conversion-selector/stores/app.store'

const COLLECTION_NAME_KEY = 'collectionNameKey'

const { t } = useI18n()
const { activeInputId, getInputState, setActiveInput, clearActiveInput } = useTableInput()
const { collection, updateCollectionName: updateCollectionNameOperation } = useAppStore()

const updateCollectionName = (name: string) => {
  updateCollectionNameOperation(name)
  clearActiveInput()
}
</script>
